module.exports = "/_next/static/images/canada-bf15b895d9d4d66eda44491fe2a69062.svg";